
import { Options } from 'vue-class-component'
import { Mixins } from 'vue-property-decorator'
import { HeaderMixin } from './mixin'
import AppSvg from '@/components/app-svg.vue'
import GoodRoadBtnSvg from './good-road-btn-svg.vue'

@Options({
    components: {
        'app-svg': AppSvg,
        'good-road-btn-svg': GoodRoadBtnSvg
    }
})
export default class PcHeader extends Mixins(HeaderMixin) { }
